import { Navigate, Route, Routes } from 'react-router-dom';
import {
  CLIENTS_PATH,
  DASHBOARD_PATH,
  DOCUMENTS_PATH,
  FREELANCERS_PATH,
  HOME_PATH, JOB_BOARD_PATH,
  PROJECT_OPPORTUNITIES_PATH,
  SETTINGS_PATH
} from './paths';
import React from 'react';
import { ColumnBoxFlexFullWidth } from '../components/common/boxes';
import Dashboard from '../components/dashboard/Dashboard';
import Freelancers from '../components/freelancers/Freelancers';
import FreelancerEntity from '../components/freelancers/freelancer-entity/FreelancerEntity';
import SettingsComponent from '../components/settings/SettingsComponent';
import Documents from '../components/documents/Documents';
import Clients from '../components/clients/Clients';
import ClientEntity from '../components/clients/client-entity/ClientEntity';
import ProjectOpportunities from '../components/project-opportunities/ProjectOpportunities';
import ProjectOpportunityEntity from '../components/project-opportunities/project-opportunity-entity/ProjectOpportunityEntity';
import JobBoard from '../components/job-board/JobBoard';


const AppRouter = () => {

  return (
    <ColumnBoxFlexFullWidth py={4}>
      <Routes>
        
        <Route path={'/'} element={<Navigate to={HOME_PATH}/>}/>
        
        <Route path={DASHBOARD_PATH} element={<Dashboard/>}/>
        
        <Route path={FREELANCERS_PATH} element={<Freelancers/>}/>
        <Route path={FREELANCERS_PATH + '/:id'} element={<FreelancerEntity/>}/>
        
        <Route path={SETTINGS_PATH} element={<SettingsComponent/>}/>
        
        <Route path={DOCUMENTS_PATH} element={<Documents/>}/>
        
        <Route path={CLIENTS_PATH} element={<Clients/>}/>
        <Route path={CLIENTS_PATH + '/:id'} element={<ClientEntity/>}/>
        
        <Route path={PROJECT_OPPORTUNITIES_PATH} element={<ProjectOpportunities/>}/>
        <Route path={PROJECT_OPPORTUNITIES_PATH + '/:clientId/:projectOpportunityId'} element={<ProjectOpportunityEntity/>}/>

        <Route path={JOB_BOARD_PATH} element={<JobBoard/>}/>

      </Routes>
    </ColumnBoxFlexFullWidth>
  );
};

export default AppRouter;